/* Comportement du selecteur de quantite et de la suppression.
   Delegation d'evenements : fonctionne aussi sur le tiroir panier, dont le
   contenu est rendu cote client APRES le chargement de la page. */
(function () {
  "use strict";

  function maj(input, delta) {
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var v = parseInt(input.value || "1", 10);
    if (isNaN(v)) v = min;
    v = Math.max(min, v + delta);
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return v;
  }

  // --- boutons + / - (fiche produit ET panier) ---
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qte-step]");
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentNode.querySelector(".qte-input, input[type=number]");
    if (input) maj(input, parseInt(btn.getAttribute("data-qte-step"), 10));
  });

  // --- panier : toute modification de ligne passe par l'API cart ---
  function changerLigne(ligne, quantite, bloc) {
    if (bloc) bloc.classList.add("qte-occupe");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: ligne, quantity: quantite })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (bloc) bloc.classList.remove("qte-occupe");
        window.location.reload();
      });
  }

  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains("qte-input")) return;
    var ligne = input.getAttribute("data-ligne");
    if (!ligne) return; // fiche produit : pas de ligne panier, rien a faire
    changerLigne(parseInt(ligne, 10), parseInt(input.value || "0", 10),
                 input.closest(".qte-ligne"));
  });


  // ------------------------------------------------------------------
  // Tiroir panier (navbar)
  // Le champ quantite EXISTE dans le gabarit Webflow mais sort en display:none,
  // d'ou un tiroir reduit au titre + "RETIRER". Son attribut name vaut exactement
  // la cle de ligne Shopify (variantId:hash), on peut donc le piloter via
  // /cart/change.js. Le tiroir etant rendu cote client, on le decore a la volee.
  // ------------------------------------------------------------------
  var POUBELLE = '<svg class="qte-suppr-icone" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h14z"/>' +
    '<path d="M10 11v6M14 11v6"/></svg>';

  function bouton(pas, libelle) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "qte-btn";
    b.setAttribute("data-qte-step", pas);
    b.setAttribute("aria-label", libelle);
    b.innerHTML = pas === "1" ? "+" : "−";
    return b;
  }

  function decorerTiroir() {
    document.querySelectorAll('[data-node-type="cart-item"]').forEach(function (it) {
      if (it.getAttribute("data-qte-fait")) return;
      var input = it.querySelector('[data-node-type="cart-quantity"]');
      if (!input) return;
      var cle = input.getAttribute("name");
      var info = it.querySelector('[data-node-type="cart-item-info"]') || it;

      var ligne = document.createElement("div");
      ligne.className = "qte-ligne";
      var st = document.createElement("div");
      st.className = "qte-stepper is-panier";
      input.classList.add("qte-input");
      input.setAttribute("data-cle", cle);
      input.setAttribute("min", "1");
      st.appendChild(bouton("-1", "Diminuer la quantite"));
      st.appendChild(input);
      st.appendChild(bouton("1", "Augmenter la quantite"));

      ligne.appendChild(st);

      // On CONSERVE le lien "Retirer" d'origine (gere par le JS Webflow) et on
      // se contente d'y glisser l'icone poubelle devant le mot.
      var lien = it.querySelector('[data-node-type="cart-remove-link"]');
      if (lien) {
        lien.classList.add("qte-suppr");
        if (!lien.querySelector(".qte-suppr-icone")) {
          lien.insertAdjacentHTML("afterbegin", POUBELLE);
        }
        ligne.appendChild(lien);
      }
      info.appendChild(ligne);
      it.setAttribute("data-qte-fait", "1");
    });
  }

  function changerCle(cle, quantite, item, bloc) {
    if (bloc) bloc.classList.add("qte-occupe");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: cle, quantity: quantite })
    })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (bloc) bloc.classList.remove("qte-occupe");
        if (quantite === 0 && item) item.remove();
        if (!panier.item_count) { window.location.reload(); return; }
        document.querySelectorAll(".w-commerce-commercecartopenlinkcount")
          .forEach(function (n) { n.textContent = panier.item_count; });
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains("qte-input")) return;
    var cle = input.getAttribute("data-cle");
    if (!cle) return;
    var item = input.closest('[data-node-type="cart-item"]');
    changerCle(cle, parseInt(input.value || "0", 10), item, input.closest(".qte-ligne"));
  });

  // (la suppression passe par le lien Webflow d'origine, pas par ce module)

  decorerTiroir();
  new MutationObserver(decorerTiroir).observe(document.documentElement,
    { childList: true, subtree: true });

  // ------------------------------------------------------------------
  // Choix de l'entreprise DANS le tiroir
  // Le champ etait sur la page /cart, ce qui imposait une etape de plus. On
  // l'injecte dans le pied du tiroir, juste au-dessus du bouton de commande :
  // le collaborateur choisit puis part directement au paiement.
  // Plan Basic : impossible de mettre ce champ sur la page de paiement
  // elle-meme (extensions reservees a Shopify Plus).
  // ------------------------------------------------------------------
  var ENTREPRISES = ["Propallia", "BrilloNettoyage"];

  function injecterEntreprise() {
    document.querySelectorAll(".w-commerce-commercecartfooter").forEach(function (pied) {
      if (pied.querySelector(".entreprise-bloc")) return;
      var bloc = document.createElement("div");
      bloc.className = "entreprise-bloc is-tiroir";
      var opts = '<option value="">Sélectionnez une entreprise</option>';
      ENTREPRISES.forEach(function (n) {
        opts += '<option value="' + n.replace(/&/g, "&amp;") + '">' + n.replace(/&/g, "&amp;") + "</option>";
      });
      bloc.innerHTML =
        '<label class="entreprise-label" for="entreprise-tiroir">Entreprise concernée' +
        '<span class="entreprise-obligatoire">*</span></label>' +
        '<select id="entreprise-tiroir" class="entreprise-select" required>' + opts + "</select>" +
        '<p class="entreprise-aide">Obligatoire avant de passer commande.</p>' +
        '<p class="entreprise-aide" data-cart-save-status role="status"></p>';
      var bouton = pied.querySelector('[data-node-type="cart-checkout-button"]');
      if (bouton && bouton.parentNode) pied.insertBefore(bloc, bouton.parentNode);
      else pied.appendChild(bloc);

      var noteBloc = document.createElement("div");
      noteBloc.className = "ns-cart-note is-tiroir";
      noteBloc.innerHTML = '<div class="ns-cart-note__heading"><label class="ns-cart-note__label" for="cart-note-tiroir">Note de commande</label><span class="ns-cart-note__optional">Facultatif</span></div>' +
        '<p class="ns-cart-note__hint" id="cart-note-tiroir-help">Une précision à transmettre à l’équipe ?</p>' +
        '<textarea id="cart-note-tiroir" name="note" class="ns-cart-note__field" rows="3" aria-describedby="cart-note-tiroir-help" placeholder="Ex. : accès au local, consigne de dépôt…"></textarea>';
      bloc.insertAdjacentElement("afterend", noteBloc);
      var note = noteBloc.querySelector("textarea");
      var noteModified = false;
      note.addEventListener("input", function () { noteModified = true; });
      var sel = bloc.querySelector("select");
      var modified = false;
      bloc.addEventListener("input", function () { modified = true; });
      // on repositionne la valeur deja enregistree dans le panier
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = p.attributes && p.attributes.Entreprise;
          if (!noteModified) note.value = p.note || "";
          if (!modified) {
            if (v) sel.value = v === "Brillo Nettoyage" ? "BrilloNettoyage" : v;
          }
        })
        .catch(function () {});

      sel.addEventListener("change", function () {
        bloc.classList.remove("entreprise-manquante");
        modified = true;
      });
    });
  }

  function retablirCheckout() {
    document.querySelectorAll('[data-node-type="cart-checkout-button"]')
      .forEach(function (b) {
        if (b.getAttribute("href") !== "/checkout") b.setAttribute("href", "/checkout");
      });
  }

  // garde-fou : pas d'entreprise, pas de commande
  document.addEventListener("click", function (e) {
    var b = e.target.closest('[data-node-type="cart-checkout-button"]');
    if (!b) return;
    var sel = document.querySelector("#entreprise-tiroir");
    if (!sel) return;
    if (!sel.value) {
      e.preventDefault();
      e.stopPropagation();
      var bloc = sel.closest(".entreprise-bloc");
      if (bloc) bloc.classList.add("entreprise-manquante");
      sel.focus();
      sel.scrollIntoView({ block: "center", behavior: "smooth" });
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.getAttribute("aria-busy") === "true") return;
    var note = document.querySelector("#cart-note-tiroir");
    var status = sel.closest(".entreprise-bloc").querySelector("[data-cart-save-status]");
    b.setAttribute("aria-busy", "true");
    status.textContent = "Enregistrement de votre commande…";
    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { Entreprise: sel.value }, note: note.value })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart-update-failed");
      return r.json();
    }).then(function (cart) {
      if (cart.attributes.Entreprise !== sel.value || (cart.note || "") !== note.value) {
        throw new Error("cart-update-not-confirmed");
      }
      window.location.assign("/checkout");
    }).catch(function () {
      b.removeAttribute("aria-busy");
      status.textContent = "Enregistrement impossible. Réessayez avant de passer commande.";
    });
  }, true);

  injecterEntreprise();
  retablirCheckout();
  new MutationObserver(function () { injecterEntreprise(); retablirCheckout(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ------------------------------------------------------------------
   Recherche predictive de la boutique collaborateurs
   ------------------------------------------------------------------ */
(function () {
  "use strict";

  var modal = document.querySelector("[data-shop-search-modal]");
  var triggers = document.querySelectorAll("[data-shop-search-open]");
  if (!modal || !triggers.length) return;
  var trigger = triggers[0];

  var input = modal.querySelector("[data-shop-search-input]");
  var form = modal.querySelector("[data-shop-search-form]");
  var results = modal.querySelector("[data-shop-search-results]");
  var heading = modal.querySelector("[data-shop-search-heading]");
  var status = modal.querySelector("[data-shop-search-status]");
  var clear = modal.querySelector("[data-shop-search-clear]");
  var emptyTemplate = modal.querySelector("[data-shop-search-empty]");
  var recommendationMarkup = results.innerHTML;
  var requestController = null;
  var debounceTimer = null;
  var lastResults = [];
  // Priorite recherche (demande cliente 08/10/2026) : configuree dans
  // navbar-e-commerce.liquid (data-ns-search-priority).
  var priority = null;
  try {
    var priorityNode = modal.querySelector("[data-ns-search-priority]");
    if (priorityNode) priority = JSON.parse(priorityNode.textContent);
  } catch (e) { priority = null; }

  function setOpen(open) {
    triggers.forEach(function (t) { t.setAttribute("aria-expanded", open ? "true" : "false"); });
    if (open) {
      modal.hidden = false;
      document.documentElement.classList.add("ns-shop-search-locked");
      window.setTimeout(function () {
        modal.classList.add("is-visible");
        input.focus();
      }, 20);
      return;
    }
    modal.classList.remove("is-visible");
    document.documentElement.classList.remove("ns-shop-search-locked");
    if (requestController) requestController.abort();
    window.setTimeout(function () {
      modal.hidden = true;
      trigger.focus();
    }, 260);
  }

  function createCard(product) {
    var link = document.createElement("a");
    var media = document.createElement("span");
    var body = document.createElement("span");
    var type = document.createElement("span");
    var title = document.createElement("span");
    var action = document.createElement("span");
    link.className = "ns-shop-search-card";
    link.href = product.url;
    media.className = "ns-shop-search-card__media";
    body.className = "ns-shop-search-card__body";
    type.className = "ns-shop-search-card__type";
    title.className = "ns-shop-search-card__title";
    action.className = "ns-shop-search-card__link";

    var image = product.image;
    var imageUrl = typeof image === "string" ? image : image && (image.url || image.src);
    if (imageUrl) {
      var img = document.createElement("img");
      img.src = imageUrl;
      img.alt = product.title || "Produit";
      img.loading = "lazy";
      media.appendChild(img);
    }
    type.textContent = product.type || "Matériel";
    title.textContent = product.title || "Produit";
    action.textContent = "Voir le produit →";
    body.appendChild(type);
    body.appendChild(title);
    body.appendChild(action);
    link.appendChild(media);
    link.appendChild(body);
    return link;
  }

  function showRecommendations() {
    lastResults = [];
    results.innerHTML = recommendationMarkup;
    heading.textContent = "Produits recommandés";
    status.textContent = "";
    clear.hidden = true;
    modal.classList.remove("is-loading");
  }

  function showEmpty(query) {
    lastResults = [];
    results.innerHTML = "";
    results.appendChild(emptyTemplate.content.cloneNode(true));
    heading.textContent = "Résultats pour « " + query + " »";
    status.textContent = "Aucun résultat";
    modal.classList.remove("is-loading");
  }

  function renderProducts(products, query) {
    lastResults = products;
    results.innerHTML = "";
    products.forEach(function (product) { results.appendChild(createCard(product)); });
    heading.textContent = "Résultats pour « " + query + " »";
    status.textContent = products.length + (products.length > 1 ? " produits trouvés" : " produit trouvé");
    modal.classList.remove("is-loading");
  }

  function uniqueProducts(products) {
    var seen = Object.create(null);
    return products.filter(function (product) {
      var key = (product.title || "").trim().toLocaleLowerCase("fr");
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 8);
  }

  function prioritize(products) {
    if (!priority || !priority.promote) return products;
    var promote = priority.promote;
    var demote = priority.demote || [];
    var promoted = null, demoted = [], rest = [];
    products.forEach(function (product) {
      if (product.handle === promote.handle) promoted = product;
      else if (demote.indexOf(product.handle) > -1) demoted.push(product);
      else rest.push(product);
    });
    if (!promoted && !demoted.length) return products;
    var head = [promoted || promote];
    return head.concat(rest.slice(0, Math.max(0, 8 - head.length - demoted.length)), demoted);
  }

  function buildPrefixQuery(query) {
    return query.split(/\s+/).filter(Boolean).map(function (term) {
      return term.replace(/\*+$/, "") + "*";
    }).join(" ");
  }

  function search(query) {
    if (requestController) requestController.abort();
    requestController = new AbortController();
    modal.classList.add("is-loading");
    status.textContent = "Recherche en cours";
    var params = new URLSearchParams();
    // Shopify ne considere pas toujours une saisie courte comme un prefixe :
    // "aci" ne renvoyait pas "Acide". Le joker sur chaque mot garde aussi
    // les recherches multi-mots progressives (ex. "aci chlo").
    params.set("q", buildPrefixQuery(query));
    params.set("resources[type]", "product");
    params.set("resources[limit]", "10");
    params.set("resources[options][unavailable_products]", "hide");
    params.set("resources[options][fields]", "title,product_type,tag,variants.sku");
    fetch("/search/suggest.json?" + params.toString(), {
      credentials: "same-origin",
      signal: requestController.signal,
      headers: { "Accept": "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("search-failed");
        return response.json();
      })
      .then(function (payload) {
        var products = payload.resources && payload.resources.results && payload.resources.results.products || [];
        products = uniqueProducts(prioritize(products));
        if (products.length) renderProducts(products, query);
        else showEmpty(query);
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;
        lastResults = [];
        results.innerHTML = "";
        results.appendChild(emptyTemplate.content.cloneNode(true));
        heading.textContent = "Recherche indisponible";
        status.textContent = "Réessayez dans quelques instants";
        modal.classList.remove("is-loading");
      });
  }

  triggers.forEach(function (t) {
    t.addEventListener("click", function () { setOpen(true); });
  });
  modal.querySelectorAll("[data-shop-search-close]").forEach(function (button) {
    button.addEventListener("click", function () { setOpen(false); });
  });
  clear.addEventListener("click", function () {
    input.value = "";
    showRecommendations();
    input.focus();
  });
  input.addEventListener("input", function () {
    var query = input.value.trim();
    clear.hidden = !query;
    window.clearTimeout(debounceTimer);
    if (query.length < 2) {
      if (requestController) requestController.abort();
      showRecommendations();
      return;
    }
    debounceTimer = window.setTimeout(function () { search(query); }, 180);
  });
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (lastResults.length) window.location.href = lastResults[0].url;
  });
  document.addEventListener("keydown", function (event) {
    if (modal.hidden) return;
    if (event.key === "Escape") setOpen(false);
  });
})();

/* ------------------------------------------------------------------
   Acces a la boutique collaborateurs
   Le cookie sans date d'expiration reste valable pendant la session du
   navigateur. Le hash evite d'exposer le code en clair dans le theme, sans
   pretendre remplacer une authentification serveur.
   ------------------------------------------------------------------ */
(function () {
  "use strict";

  var modal = document.querySelector("[data-employee-access]");
  if (!modal) return;

  var SESSION_COOKIE = "ns_employee_shop=unlocked";
  var EXPECTED_HASH = "fd7153335627c9fe4200bf31a9a428527c86daeafa960dd743a72dec069e3a95";
  var form = modal.querySelector("[data-employee-access-form]");
  var input = modal.querySelector("#employee-access-code");
  var error = modal.querySelector("[data-employee-access-error]");
  var submit = modal.querySelector(".employee-access__submit");

  function sessionOuverte() {
    return document.cookie.split(";").some(function (item) {
      return item.trim() === SESSION_COOKIE;
    });
  }

  function afficher() {
    modal.hidden = false;
    document.documentElement.classList.add("employee-access-locked");
    window.setTimeout(function () {
      modal.classList.add("is-visible");
      input.focus();
    }, 30);
  }

  function fermer() {
    document.cookie = SESSION_COOKIE + "; path=/; SameSite=Lax";
    modal.classList.remove("is-visible");
    document.documentElement.classList.remove("employee-access-locked");
    window.setTimeout(function () { modal.remove(); }, 260);
  }

  function sha256(value) {
    var data = new TextEncoder().encode(value);
    return window.crypto.subtle.digest("SHA-256", data).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
    });
  }

  if (sessionOuverte()) {
    modal.remove();
    return;
  }

  afficher();

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    error.textContent = "";
    modal.classList.remove("has-error");

    if (!/^[0-9]{4}$/.test(input.value)) {
      error.textContent = "Saisissez les quatre chiffres du code d’accès.";
      modal.classList.add("has-error");
      input.focus();
      return;
    }

    submit.disabled = true;
    submit.textContent = "Vérification…";
    sha256(input.value).then(function (hash) {
      if (hash === EXPECTED_HASH) {
        fermer();
        return;
      }
      error.textContent = "Ce code n’est pas reconnu. Vérifiez-le puis réessayez.";
      modal.classList.add("has-error");
      input.select();
      submit.disabled = false;
      submit.textContent = "Accéder à la boutique";
    }).catch(function () {
      error.textContent = "La vérification est momentanément indisponible.";
      submit.disabled = false;
      submit.textContent = "Accéder à la boutique";
    });
  });
})();
